const scrollTo = (to, duration) => {
    let start = window.scrollY,
        change = to - start,
        currentTime = 0,
        increment = 20;

    let animateScroll = () => {
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        window.scroll(0, val);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

const scrollDown = (elementClass, offset) => {
    let element = document.querySelector(elementClass);
    let elemPos = element ? element.getBoundingClientRect().top + window.pageYOffset : 0;
    scrollTo((elemPos + offset), 1250)
}


const scrollToElement = (containerClass, elementId, duration, width) => {
    let container = document.getElementsByClassName(containerClass)[0];
    if (container) {
        let elem = document.getElementById(elementId);
        let centerElement = elem.offsetLeft + (typeof width !== "undefined" ? width : elem.offsetWidth) / 2;
        let centerContainer = container.offsetLeft + container.offsetWidth / 2;

        let to = centerElement - centerContainer;
        let start = container.scrollLeft,
            change = to - start,
            currentTime = 0,
            increment = 10;

        let animateScroll = () => {
            currentTime += increment;
            let val = Math.easeInOutQuad(currentTime, start, change, duration);
            container.scrollLeft = val;
            if (currentTime < duration) {
                setTimeout(animateScroll, increment);
            }
        };
        animateScroll();

        // container.scrollLeft = centerElement - centerContainer; //((imageWidth - elem.offsetWidth) / 2);
    }
}

Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

export {
    scrollDown,
    scrollTo,
    scrollToElement
}


// WEBPACK FOOTER //
// ./src/Components/Services/scrollAnimation.js